import { useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import axios from "axios";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

function Consultation() {
    const { t } = useTranslation();
    const location = useLocation();

    const [formData, setFormData] = useState({
        name: "",
        email: "",
        phone: "",
        text: "",
        checkbox: false
    });

    const [errors, setErrors] = useState({
        name: "",
        email: "",
        phone: "",
        text: "",
        checkbox: ""
    });

    const [isMobile, setIsMobile] = useState(window.innerWidth < 1280);

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth < 1280);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState({ type: "", text: "" });

    useEffect(() => {
        if (location.state) {
            setFormData((prev) => ({ ...prev, ...location.state }));
        }
    }, [location.state]);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const validateName = (name) => {
        if (!name.trim()) return t("cons.fill_name");
        if (name.trim().length < 2) return t("cons.invalid_name");
        return "";
    };

    const validateEmail = (email) => {
        if (!email.trim()) return t("cons.fill_email");
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email.trim())) {
            return t("cons.invalid_email");
        }
        return "";
    };

    const validatePhone = (phone) => {
        if (!phone.trim()) return t("cons.fill_phone");

        // Убираем всё кроме цифр
        const digits = phone.replace(/\D/g, "");

        // Базовая проверка международного номера
        if (digits.length < 10 || digits.length > 15) {
            return t("cons.invalid_phone");
        }

        return "";
    };

    const validateText = (text) => {
        if (!text.trim()) return t("cons.fill_text");
        if (text.trim().length < 10) {
            return t("cons.invalid_text");
        }
        return "";
    };

    const validateCheckbox = (checkbox) => {
        if (!checkbox) {
            return t("cons.accept_policy");
        }
        return "";
    };

    const validateField = (name, value) => {
        switch (name) {
            case "name":
                return validateName(value);
            case "email":
                return validateEmail(value);
            case "phone":
                return validatePhone(value);
            case "text":
                return validateText(value);
            case "checkbox":
                return validateCheckbox(value);
            default:
                return "";
        }
    };

    const validateForm = () => {
        const newErrors = {
            name: validateName(formData.name),
            email: validateEmail(formData.email),
            phone: validatePhone(formData.phone),
            text: validateText(formData.text),
            checkbox: validateCheckbox(formData.checkbox)
        };

        setErrors(newErrors);

        return !Object.values(newErrors).some(Boolean);
    };

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        const fieldValue = type === "checkbox" ? checked : value;

        setFormData((prev) => ({
            ...prev,
            [name]: fieldValue
        }));

        setErrors((prev) => ({
            ...prev,
            [name]: validateField(name, fieldValue)
        }));
    };

    const handlePhoneChange = (value) => {
        setFormData((prev) => ({
            ...prev,
            phone: value
        }));

        setErrors((prev) => ({
            ...prev,
            phone: validatePhone(value)
        }));
    };

    const handleSubmit = async () => {
        if (!validateForm()) {
            setMessage({ type: "error", text: t("cons.fix_errors")});
            return;
        }

        setLoading(true);
        setMessage({ type: "", text: "" });

        try {
            await axios.post("https://civbt.xyz/api/bot/gmryAzaJDp", formData);

            setMessage({ type: "success", text: t("cons.success") });

            setFormData({
                name: "",
                email: "",
                phone: "",
                text: "",
                checkbox: false
            });

            setErrors({
                name: "",
                email: "",
                phone: "",
                text: "",
                checkbox: ""
            });
        } catch (error) {
            console.error(error);
            setMessage({ type: "error", text: t("cons.error") });
        } finally {
            setLoading(false);
        }
    };
    const [phoneCountry, setPhoneCountry] = useState();
        useEffect(() => {
        const detectCountryByIp = async () => {
            try {
                const { data } = await axios.get("https://ipapi.co/json/");
                if (data?.country_code) {
                    setPhoneCountry(data.country_code.toLowerCase());
                }
            } catch (error) {

            }
        };

        detectCountryByIp();
    }, []);

    return (
        <div className="bg-[#FFFFFF] pt-[80px] xl:pt-[140px]">
            <div className="max-w-[915px] mx-[20px] xl:mx-auto flex flex-col items-center">
                <p className="host-grostesk leading-[1.2] text-[28px] xl:text-[40px] max-w-[350px] sm:max-w-max text-center">
                    {t("cons.1")}
                </p>

                <p className="text-[#000000B2] PtRoot text-[12px] xl:text-[14px] md:max-w-[517px] text-center mt-[10px]">
                    {t("cons.2")}
                </p>

                <p className="text-center text-[12px] xl:text-[14px] font-[700] text-[#000000B2] PtRoot py-[12px] mt-[12px] w-full rounded-[5px] px-[20px]">
                    {t("cons.3")}
                </p>

                <div className="flex flex-col xl:flex-row gap-[12px] xl:gap-[40px] w-full mt-[40px]">
                    <div className="w-full flex flex-col gap-[12px]">
                        <div>
                            <p className="px-[32px] PtRoot text-[10px] font-[500] text-[#000000B2]">
                                {t("cons.4")}
                            </p>
                            <input
                                name="name"
                                value={formData.name}
                                type="text"
                                onChange={handleChange}
                                placeholder={t("cons.5")}
                                className={`PtRoot w-full border-[2px] xl:border-[1px] bg-transparent rounded-md px-[32px] py-3 text-[14px] focus:outline-none placeholder-[#00000080] ${
                                    errors.name
                                        ? "border-red-500 focus:border-red-500"
                                        : "border-[#0000001A] focus:border-[#2A323F]"
                                }`}
                            />
                            {errors.name && (
                                <p className="text-red-500 text-[12px] mt-1 px-[32px]">{errors.name}</p>
                            )}
                        </div>

                        <div>
                            <p className="px-[32px] PtRoot text-[10px] font-[500] text-[#000000B2]">
                                {t("cons.6")}
                            </p>
                            <input
                                name="email"
                                value={formData.email}
                                type="email"
                                onChange={handleChange}
                                placeholder={t("cons.7")}
                                className={`PtRoot w-full border-[2px] xl:border-[1px] bg-transparent rounded-md px-[32px] py-3 text-[14px] focus:outline-none placeholder-[#00000080] ${
                                    errors.email
                                        ? "border-red-500 focus:border-red-500"
                                        : "border-[#0000001A] focus:border-[#2A323F]"
                                }`}
                            />
                            {errors.email && (
                                <p className="text-red-500 text-[12px] mt-1 px-[32px]">{errors.email}</p>
                            )}
                        </div>

                        <div>
                            <p className="px-[32px] PtRoot text-[10px] font-[500] text-[#000000B2]">
                                {t("cons.8")}
                            </p>

                            <div className={`${errors.phone ? "phone-error" : ""}`}>
                                <PhoneInput
                                    country={phoneCountry}
                                    value={formData.phone}
                                    onChange={handlePhoneChange}
                                    enableSearch={true}
                                    disableSearchIcon={true}
                                    countryCodeEditable={false}
                                    placeholder={t("cons.9")}
                                    inputStyle={{
                                        width: "100%",
                                        height: "48px",
                                        borderRadius: "10px",
                                        border: errors.phone
                                        ? `${isMobile ? 2 : 1}px solid #ef4444`
                                        : `${isMobile ? 2 : 1}px solid rgba(0,0,0,0.1)`,
                                        background: "transparent",
                                        paddingLeft: "70px",
                                        fontSize: "14px",
                                        fontFamily: "inherit"
                                    }}
                                    buttonStyle={{
                                        border: "none",
                                        background: "transparent",
                                        borderRight: "1px solid rgba(0,0,0,0.08)",
                                        borderRadius: "6px 0 0 6px"
                                    }}
                                    containerStyle={{
                                        width: "100%"
                                    }}
                                    dropdownStyle={{
                                        borderRadius: "10px",
                                        border: "1px solid rgba(0,0,0,0.1)"
                                    }}
                                />
                            </div>

                            {errors.phone && (
                                <p className="text-red-500 text-[12px] mt-1 px-[32px]">{errors.phone}</p>
                            )}
                        </div>
                    </div>

                    <div className="w-full">
                        <p className="px-[32px] PtRoot text-[10px] font-[500] text-[#000000B2]">
                            {t("cons.10")}
                        </p>
                        <textarea
                            name="text"
                            value={formData.text}
                            onChange={handleChange}
                            placeholder={t("cons.11")}
                            rows={3}
                            className={`PtRoot w-full border-[2px] xl:border-[1px] bg-transparent rounded-md px-[32px] py-3 h-[194px] text-[14px] focus:outline-none placeholder-[#00000080] resize-none ${
                                errors.text
                                    ? "border-red-500 focus:border-red-500"
                                    : "border-[#0000001A] focus:border-[#2A323F]"
                            }`}
                        />
                        {errors.text && (
                            <p className="text-red-500 text-[12px] mt-1 px-[32px]">{errors.text}</p>
                        )}
                    </div>
                </div>

                <label className="flex items-center mr-auto gap-2 text-[12px] xl:text-[14px] text-[#000000B2] cursor-pointer PtRoot font-[700] mt-[20px]">
                    <input
                        name="checkbox"
                        type="checkbox"
                        checked={formData.checkbox}
                        onChange={handleChange}
                        className="accent-[#3ea138] w-[14px] h-[14px]"
                    />
                    {t("cons.12")}
                </label>

                {errors.checkbox && (
                    <p className="mr-auto text-red-500 text-[12px] mt-1">{errors.checkbox}</p>
                )}

                <button
                    onClick={handleSubmit}
                    disabled={loading}
                    className="rounded-[60px] bg-[#3ea138] mt-[20px] xl:mt-[32px] text-white uppercase PtRoot font-[700] py-[14px] px-[40px] hover:px-[20px] transition-all disabled:opacity-50"
                >
                    {loading ? t("cons.sending") : t("home.46")}
                </button>

                {message.text && (
                    <p
                        className={`mt-4 text-[14px] ${
                            message.type === "error" ? "text-red-600" : "text-green-600"
                        }`}
                    >
                        {message.text}
                    </p>
                )}
            </div>
        </div>
    );
}

export default Consultation;
